export const createSlug = (title, eventData = null) => {
    // Utiliser directement le slug de l'API si disponible
    if (eventData?.slug) {
        return eventData.slug;
    }

    if (!title) return '';

    let titleText = title;

    // Si le titre est un objet (comme dans le cas des données WP render)
    if (typeof title === 'object' && title.rendered) {
        titleText = title.rendered;
    }

    // Convertir la chaîne HTML en texte brut si nécessaire
    const decodedText = titleText
        .replace(/&amp;/g, '&') // Remplacer &amp; par &
        .replace(/&lt;/g, '<') // Remplacer &lt; par <
        .replace(/&gt;/g, '>') // Remplacer &gt; par >
        .replace(/&quot;/g, '"') // Remplacer &quot; par "
        .replace(/&#039;/g, "'") // Remplacer &#039; par '
        .replace(/<[^>]*>/g, '') // Supprimer les balises HTML
        .replace(/\s+/g, ' ') // Remplacer les espaces multiples par un seul espace
        .trim() // Supprimer les espaces au début et à la fin
        .replace(/&/g, 'et') // Remplacer & par 'et' pour plus de clarté
        .replace(/'/g, '') // Supprimer les apostrophes
        .replace(/['']/g, ''); // Supprimer les apostrophes typographiques
    
    const slug = decodedText
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "") // Supprimer les accents
        .replace(/[^a-z0-9\s-]+/g, "") // Supprimer tous les caractères spéciaux sauf les espaces et tirets
        .replace(/\s+/g, "-") // Remplacer les espaces par des tirets
        .replace(/-+/g, "-") // Remplacer les tirets multiples par un seul
        .replace(/^-+|-+$/g, ""); // Supprimer les tirets au début et à la fin

    return slug;
};